import { defineMessages } from 'react-intl'


export default defineMessages({
  scanning: {
    id: 'welcome-guide-layout.scanning',
    defaultMessage: 'SCANNING',
  },
})

